<template>
	<div class="small-6 medium-6 columns">
		<div class="switch float-right">
		<Field
			:id="name + '-radio-option-no'"
			v-model="selectedRadioOption"
			@change="onChange(false)"
			type="radio"
			class="switch-input"
			:name="name"
			:value="false"
		/>
		<label
			:for="name + '-radio-option-no'"
			class="switch-label switch-label-left unselectable"
			v-html="noOptionLabel"
			:data-test="dataTestNo"
		/>
		<Field
			:id="name + '-radio-option-yes'"
			v-model="selectedRadioOption"
			@change="onChange(true)"
			type="radio"
			class="switch-input"
			:name="name"
			:value="true"
		/>
		<label
			:for="name + '-radio-option-yes'"
			class="switch-label switch-label-right unselectable"
			v-html="yesOptionLabel"
			:data-test="dataTestYes"
		/>
		<span class="selection-indicator" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'RadioButtonsCapsulePill',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
			default() {
				return true;
			}
		},
		name: {
			type: String,
			default() {
				return '';
			}
		},
		dataTestYes: {
			type: String,
			default() {
				return 'radio-button-pill-yes';
			}
		},
		dataTestNo: {
			type: String,
			default() {
				return 'radio-button-pill-no';
			}
		},
	},
	data() {
		return {
			yesOptionLabel: 'Ja',
			noOptionLabel: 'Nej',
			selectedRadioOption: true
		};
	},
	created() {
		this.selectedRadioOption = this.modelValue;
	},
	watch: {
		'modelValue': function (val) {
			this.selectedRadioOption = val;
		}
	},
	methods: {
		onChange(value) {
			this.$emit('update:modelValue', value);
		}
	}
};
</script>